export const WS_UPDATE_MODEL = 'update-model';
